import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("@/views/main/index.vue"),
    meta: { title: "商品首页", auth: true },
    redirect: "/goodsInfo",
    children: [
      {
        path: "goodsInfo",
        component: () => import("@/views/goods/goodsInfo.vue"),
        meta: { title: "首页", auth: true },
      },
      {
        path: "goodsCate",
        component: () => import("@/views/goods/goodsCate.vue"),
        meta: { title: "分类", auth: true },
      },
      {
        path: "goodsDetail",
        component: () => import("@/views/goods/goodsDetail.vue"),
        meta: { title: "商品详情", auth: true },
      },
      {
        path: "goodSearch",
        component: () => import("@/views/goods/goodSearch.vue"),
        meta: { title: "商品搜索", auth: true },
      },
    ],
  },
  {
    path: "/transaction",
    component: () => import("@/views/main/indexs.vue"),
    redirect: "/home_management",
    meta: { title: "交易管理", auth: true },
    children: [
      {
        path: "/overview",
        component: () => import("@/views/transaction/overview.vue"),
        meta: { title: "交易总览", auth: true },
      },
      {
        path: "/tradedata",
        component: () => import("@/views/transaction/tradedata.vue"),
        meta: { title: "交易核心数据", auth: true },
      },
      {
        path: "/growth_center",
        component: () => import("@/views/transaction/growth_center.vue"),
        meta: { title: "交易成长中心", auth: true },
      },
      {
        path: "/smartTaxProvisions",
        component: () => import("@/views/exportss/smartTaxProvisions.vue"),
        meta: { title: "智慧税则", auth: true },
      },
      {
        path: "/customs_declaration",
        component: () => import("@/views/exportss/customs_declaration.vue"),
        meta: { title: "报关管理", auth: true },
      },


    ]
  },
  {
    path: "/exportss",
    component: () => import("@/views/main/indexs.vue"),
    redirect: "/home_management",
    meta: { title: "出口服务", auth: true },
    children: [
      {
        path: "/service_order",
        component: () => import("@/views/exportss/service_order.vue"),
        meta: { title: "出口服务下单", auth: true },
      },
      {
        path: "/export_services",
        component: () => import("@/views/exportss/export_services.vue"),
        meta: { title: "出口工作台", auth: true },
      },
      {
        path: "/brandManagement",
        component: () => import("@/views/exportss/brandManagement.vue"),
        meta: { title: "品牌管理", auth: true },
      },
      {
        path: "/productManagement",
        component: () => import("@/views/exportss/productManagement.vue"),
        meta: { title: "产品管理", auth: true },
      },
      {
        path: "/ticketIssuerManagement",
        component: () => import("@/views/exportss/ticketIssuerManagement.vue"),
        meta: { title: "开票人管理", auth: true },
      },
      {
        path: "/compliance_services",
        component: () => import("@/views/exportss/compliance_services.vue"),
        meta: { title: "合规服务", auth: true },
      },
      {
        path: "/ordersSaleServices",
        component: () => import("@/views/exportss/ordersSaleServices.vue"),
        meta: { title: "服务售卖订单", auth: true },
      },
      {
        path: "/expressExportOrder",
        component: () => import("@/views/exportss/expressExportOrder.vue"),
        meta: { title: "快递出口订单", auth: true },
      },
      {
        path: "/certificate",
        component: () => import("@/views/exportss/certificate.vue"),
        meta: { title: "办证服务", auth: true },
      },
      {
        path: "/collection_invoice",
        component: () => import("@/views/exportss/collection_invoice.vue"),
        meta: { title: "业务预警", auth: true },
      },
      {
        path: "/seal",
        component: () => import("@/views/exportss/seal.vue"),
        meta: { title: "盖章服务", auth: true },
      },
      {
        path: "/declarationDocuments",
        component: () => import("@/views/exportss/declarationDocuments.vue"),
        meta: { title: "报关单证制作", auth: true },
      },
      {
        path: "/taxRefundEnquiries",
        component: () => import("@/views/exportss/taxRefundEnquiries.vue"),
        meta: { title: "退税款查询", auth: true },
      },

      {
        path: "/informationManagement",
        component: () => import("@/views/exportss/informationManagement.vue"),
        meta: { title: "函调信息管理", auth: true },
      },
      {
        path: "/taxRefundInvoice",
        component: () => import("@/views/exportss/taxRefundInvoice.vue"),
        meta: { title: "退税发票管理", auth: true },
      },
      {
        path: "/document_filing",
        component: () => import("@/views/exportss/document_filing.vue"),
        meta: { title: "备案单证", auth: true },
      },
      {
        path: "/listAgentCards",
        component: () => import("@/views/exportss/listAgentCards.vue"),
        meta: { title: "代理证列表", auth: true },
      },
      {
        path: "/mo_basedata",
        component: () => import("@/views/exportss/moBasedata.vue"),
        meta: { title: "代理证列表", auth: true },
      },
      {
        path: "/classroom",
        component: () => import("@/views/exportss/classroom.vue"),
        meta: { title: "代理证列表", auth: true },
      },

    ]
  },
  {
    path: "/logistics",
    component: () => import("@/views/main/indexs.vue"),
    redirect: "/home_management",
    meta: { title: "物流服务", auth: true },
    children: [
      {
        path: "/logistics_service",
        component: () => import("@/views/logistics/logistics_service.vue"),
        meta: { title: "查询物流方案", auth: true },
      },
      {
        path: "/LandSea_orders",
        component: () => import("@/views/logistics/LandSea_orders.vue"),
        meta: { title: "海陆订单", auth: true },
      },
      {
        path: "/empty_fast_order",
        component: () => import("@/views/logistics/empty_fast_order.vue"),
        meta: { title: "空快订单", auth: true },
      },
      {
        path: "/ocean_lcl_list",
        component: () => import("@/views/logistics/ocean_lcl_list.vue"),
        meta: { title: "海拼订单管理", auth: true },
      },
      {
        path: "/logistics_disposal",
        component: () => import("@/views/logistics/logistics_disposal.vue"),
        meta: { title: "物流履约分", auth: true },
      },
      {
        path: "/freight",
        component: () => import("@/views/logistics/freight.vue"),
        meta: { title: "运费模板", auth: true },
      },
      {
        path: "/semi_managed_trial",
        component: () => import("@/views/logistics/semi_managed_trial.vue"),
        meta: { title: "物流运费试算", auth: true },
      },
      {
        path: "/semi_managed_address",
        component: () => import("@/views/logistics/semi_managed_address.vue"),
        meta: { title: "半托管揽收地址", auth: true },
      },
      {
        path: "/customer_equity",
        component: () => import("@/views/logistics/customer_equity.vue"),
        meta: { title: "物流客户权益", auth: true },
      },
    ]
  },
  {
    path: "/capital",
    component: () => import("@/views/main/indexs.vue"),
    redirect: "/home_management",
    meta: { title: "资金金融", auth: true },
    children: [
      {
        path: "/home",
        component: () => import("@/views/capital/home.vue"),
        meta: { title: "账户总览", auth: true },
      },
      {
        path: "/money_management",
        component: () => import("@/views/capital/money_management.vue"),
        meta: { title: "资金总览", auth: true },
      },
      {
        path: "/reconciliation_funds",
        component: () => import("@/views/capital/reconciliation_funds.vue"),
        meta: { title: "资金明细", auth: true },
      },
      {
        path: "/forex_list",
        component: () => import("@/views/capital/forex_list.vue"),
        meta: { title: "外汇到账", auth: true },
      },
      {
        path: "/collection",
        component: () => import("@/views/capital/collection.vue"),
        meta: { title: "托收", auth: true },
      },
      {
        path: "/refund_list",
        component: () => import("@/views/capital/refund_list.vue"),
        meta: { title: "退汇", auth: true },
      },
      {
        path: "/settlement",
        component: () => import("@/views/capital/settlement.vue"),
        meta: { title: "结汇", auth: true },
      },
      {
        path: "/forward",
        component: () => import("@/views/capital/forward.vue"),
        meta: { title: "锁汇", auth: true },
      },
      {
        path: "/financing_service",
        component: () => import("@/views/capital/financing_service.vue"),
        meta: { title: "融资服务", auth: true },
      },
      {
        path: "/insurance",
        component: () => import("@/views/capital/insurance.vue"),
        meta: { title: "保险及资信服务", auth: true },
      },
      {
        path: "/payment_fees",
        component: () => import("@/views/capital/payment_fees.vue"),
        meta: { title: "费用缴纳", auth: true },
      },
      {
        path: "/issue_invoice",
        component: () => import("@/views/capital/issue_invoice.vue"),
        meta: { title: "开发票", auth: true },
      },
      {
        path: "/account",
        component: () => import("@/views/capital/account.vue"),
        meta: { title: "账户于安全", auth: true },
      },
    ]
  },
  {
    path: "/certification",
    component: () => import("@/views/main/indexs.vue"),
    redirect: "/home_management",
    meta: { title: "认证中心", auth: true },
    children: [
      {
        path: "/certificate_management",
        component: () =>
          import("@/views/certification/certificate_management.vue"),
        meta: { title: "A&V认证", auth: true },
      },
      {
        path: "/industry_service",
        component: () =>
          import("@/views/certification/industry_service.vue"),
        meta: { title: "行业服务准入", auth: true },
      },
      {
        path: "/auth_result",
        component: () =>
          import("@/views/certification/auth_result.vue"),
        meta: { title: "实地认证进展", auth: true },
      },
    ]
  },
  {
    path: "/ta_sell",
    component: () => import("@/views/transaction/ta_sell.vue"),
    meta: { title: "起草信用保障订单", auth: true },
  },

  {
    path: "/indexs",
    component: () => import("@/views/main/indexs.vue"),
    redirect: "/home_management",
    children: [
      {
        path: "/baojia_list",
        component: () => import("@/views/opportunity/baojia_list.vue"),
        meta: { title: "报价管理", auth: true },
      },
      {
        path: "/RFQxunpan",
        component: () => import("@/views/opportunity/RFQxunpan.vue"),
        meta: { title: "RFQ", auth: true },
      },
      {
        path: "/RFQshangji",
        component: () => import("@/views/opportunity/RFQshangji.vue"),
        meta: { title: "RFQ", auth: true },
      },
      {
        path: "/opportunity_basic",
        component: () => import("@/views/opportunity/basic.vue"),
        meta: { title: "咨询分配设置", auth: true },
      },
      {
        path: "/opportunity_quotation",
        component: () => import("@/views/opportunity/quotation.vue"),
        meta: { title: "我的权益", auth: true },
      },
      {
        path: "/opportunity_my_buyers_list",
        component: () => import("@/views/opportunity/my_buyers_list.vue"),
        meta: { title: "我的买家", auth: true },
      },
      {
        path: "/home_management",
        component: () => import("@/views/main/home_management.vue"),
        meta: { title: "首页", auth: true },
      },

      {
        path: "/certificate_upload",
        component: () => import("@/views/certification/certificate_upload.vue"),
        meta: { title: "证书上传", auth: true },
      },
      {
        path: "/capability_assessment_report",
        component: () =>
          import("@/views/certification/capability_assessment_report.vue"),
        meta: { title: "能力评估报告", auth: true },
      },
      {
        path: "/store_management",
        component: () => import("@/views/store_mg/store_management.vue"),
        meta: { title: "全球旺铺", auth: true },
      },
      {
        path: "/manage_company_information",
        component: () =>
          import("@/views/store_mg/manage_company_information.vue"),
        meta: { title: "管理公司信息", auth: true },
      },
      {
        path: "/domain_name_management",
        component: () => import("@/views/store_mg/domain_name_management.vue"),
        meta: { title: "域名管理", auth: true },
      },
      {
        path: "/store_dynamics",
        component: () => import("@/views/store_mg/store_dynamics.vue"),
        meta: { title: "店铺动态管理", auth: true },
      },
      {
        path: "/trade_record",
        component: () => import("@/views/store_mg/trade_record.vue"),
        meta: { title: "贸易记录", auth: true },
      },

      {
        path: "/product_management",
        name: "product_management",
        component: () => import("@/views/product/product_management.vue"),
        meta: { title: "产品管理", auth: true },
      },
      {
        path: "/product_growth",
        component: () => import("@/views/product/product_growth.vue"),
        meta: { title: "优品运营", auth: true },
      },

      {
        path: "/collect_product",
        component: () => import("@/views/product/collect_product.vue"),
        meta: { title: "行业定向征品", auth: true },
      },
      {
        path: "/semi_managed",
        component: () => import("@/views/product/semi_managed.vue"),
        meta: { title: "半托管理", auth: true },
      },
      {
        path: "/operate",
        component: () => import("@/views/product/operate.vue"),
        meta: { title: "管理平台新品", auth: true },
      },
      {
        path: "/picture_bank",
        component: () => import("@/views/product/picture_bank.vue"),
        meta: { title: "图片银行", auth: true },
      },
      {
        path: "/video_bank",
        component: () => import("@/views/product/video_bank.vue"),
        meta: { title: "视频银行", auth: true },
      },
      {
        path: "/mark_center",
        component: () => import("@/views/market_center/mark_center.vue"),
        meta: { title: "营销中心", auth: true },
      },
      {
        path: "/topranking_plus",
        component: () => import("@/views/market_center/topranking_plus.vue"),
        meta: { title: "顶级展位", auth: true },
      },
      {
        path: "/showcase_index",
        component: () => import("@/views/showcase/index.vue"),
        meta: { title: "橱窗产品", auth: true },
      },
      {
        path: "/showcase_promotion",
        component: () => import("@/views/showcase/promotion.vue"),
        meta: { title: "推广管理", auth: true },
      },
      {
        path: "/showcase_supereme",
        component: () => import("@/views/showcase/supereme.vue"),
        meta: { title: "问鼎营销", auth: true },
      },
      {
        path: "/showcase_brand_zone",
        component: () => import("@/views/showcase/brand_zone.vue"),
        meta: { title: "问鼎营销", auth: true },
      },
      {
        path: "/showcase_year_frame",
        component: () => import("@/views/showcase/year_frame.vue"),
        meta: { title: "营销年框", auth: true },
      },
      {
        path: "/showcase_star_booth",
        component: () => import("@/views/showcase/star_booth.vue"),
        meta: { title: "关键词购买", auth: true },
      },
      {
        path: "/showcase_enterprise_card",
        component: () => import("@/views/showcase/enterprise_card.vue"),
        meta: { title: "超级企业名片", auth: true },
      },
      {
        path: "/enroll_home",
        component: () => import("@/views/enroll/home.vue"),
        meta: { title: "官方活动报名", auth: true },
      },
      {
        path: "/enroll_activity_list",
        component: () => import("@/views/enroll/activity_list.vue"),
        meta: { title: "已报名活动", auth: true },
      },
      {
        path: "/enroll_seller_activity_list",
        component: () => import("@/views/enroll/seller_activity_list.vue"),
        meta: { title: "限时折扣", auth: true },
      },
      {
        path: "/enroll_seller_coupon_list",
        component: () => import("@/views/enroll/seller_coupon_list.vue"),
        meta: { title: "优惠款", auth: true },
      },
      {
        path: "/enroll_combination_list",
        component: () => import("@/views/enroll/combination_list.vue"),
        meta: { title: "场景搭配", auth: true },
      },
      {
        path: "/enroll_seller_activity_list",
        component: () => import("@/views/enroll/seller_activity_list.vue"),
        meta: { title: "已报名活动", auth: true },
      },
      {
        path: "/new_promotion",
        component: () => import("@/views/market_center/new_promotion.vue"),
        meta: { title: "新建推广", auth: true },
      },
      {
        path: "/search_promotion",
        component: () => import("@/views/market_center/search_promotion.vue"),
        meta: { title: "搜索推广", auth: true },
      },







      {
        path: "/data_analysis",
        component: () => import("@/views/data_analysis/analysis.vue"),
        meta: { title: "数据分析", auth: true },
      },

      {
        path: "/business_growth",
        component: () => import("@/views/main/business_growth.vue"),
        meta: { title: "商家成长", auth: true },
      },
      {
        path: "/exitWorkTable",
        component: () => import("@/views/exportss/exitWorkTable.vue"),
        meta: { title: "出口服务", auth: true },
      },
      {
        path: "/transaction_management",
        component: () =>
          import("@/views/transaction/transaction_management.vue"),
        meta: { title: "交易管理", auth: true },
      },
      {
        path: "/release_true_view",
        component: () => import("@/views/media_center/release_true_view.vue"),
        meta: { title: "发布True View视频", auth: true },
      },
      {
        path: "/customers_list",
        component: () => import("@/views/customer/customers_list.vue"),
        meta: { title: "客户列表", auth: true },
      },
      {
        path: "/fans_list",
        component: () => import("@/views/customer/fans_list.vue"),
        meta: { title: "粉丝列表", auth: true },
      },
      {
        path: "/high_seas_customers",
        component: () => import("@/views/customer/high_seas_customers.vue"),
        meta: { title: "公海客户", auth: true },
      },
      {
        path: "/open_sea",
        component: () => import("@/views/customer/open_sea.vue"),
        meta: { title: "公海设置", auth: true },
      },
      {
        path: "/level_setting",
        component: () =>
          import("@/views/customer/level_setting.vue"),
        meta: { title: "客群管理", auth: true },
      },
      {
        path: "/customer_marketing",
        component: () =>
          import("@/views/customer/customer_marketing.vue"),
        meta: { title: "客户营销", auth: true },
      },
      {
        path: "/mailadd",
        component: () => import("@/views/customer/mailadd.vue"),
        meta: { title: "新增模板", auth: true },
      },
      {
        path: "/product_analysis",
        component: () => import("@/views/data_analysis/product_analysis.vue"),
        meta: { title: "产品分析", auth: true },
      },
      {
        path: "/zero_effect_product",
        component: () =>
          import("@/views/data_analysis/zero_effect_product.vue"),
        meta: { title: "零效果产品", auth: true },
      },
      {
        path: "/key_words",
        component: () => import("@/views/data_analysis/key_words.vue"),
        meta: { title: "关键词指数", auth: true },
      },

      {
        path: "/grouping_sorting",
        component: () => import("@/views/product/grouping_sorting.vue"),
        meta: { title: "产品分组与排序", auth: true },
      },
      {
        path: "/product_operation_table",
        component: () => import("@/views/product/product_operation_table.vue"),
        meta: { title: "产品运营工作台", auth: true },
      },
      {
        path: "/recycling_station",
        component: () => import("@/views/customer/recycling_station.vue"),
        meta: { title: "回收站", auth: true },
      },
      {
        path: "/search_diagnosis",
        component: () => import("@/views/product/search_diagnosis.vue"),
        meta: { title: "搜索诊断首页", auth: true },
      },
      {
        path: "/manage_picture_bank",
        component: () => import("@/views/product/manage_picture_bank.vue"),
        meta: { title: "管理图片银行", auth: true },
      },
      {
        path: "/manage_video_bank",
        component: () => import("@/views/product/manage_video_bank.vue"),
        meta: { title: "管理视频银行", auth: true },
      },
      {
        path: "/portrait_visitor",
        component: () => import("@/views/data_analysis/portrait_visitor.vue"),
        meta: { title: "访客画像", auth: true },
      },
      {
        path: "/key_words_drainage",
        component: () => import("@/views/data_analysis/key_words_drainage.vue"),
        meta: { title: "引流关键词", auth: true },
      },
      {
        path: "/source_traffic",
        component: () => import("@/views/data_analysis/source_traffic.vue"),
        meta: { title: "流量来源", auth: true },
      },




      {
        path: "/market",
        component: () => import("@/views/exportss/market.vue"),
        meta: { title: "垫付退税大盘", auth: true },
      },
      {
        path: "/ddvanceAmountTaxRefund",
        component: () => import("@/views/exportss/ddvanceAmountTaxRefund.vue"),
        meta: { title: "垫付退税额度", auth: true },
      },





      {
        path: "/customerService",
        component: () => import("@/views/exportss/customerService.vue"),
        meta: { title: "客户服务", auth: true },
      },




      {
        path: "/orderRecyclingStation",
        component: () =>
          import("@/views/transaction/orderRecyclingStation.vue"),
        meta: { title: "订单回收站", auth: true },
      },
      {
        path: "/QuotaManagement",
        component: () => import("@/views/transaction/QuotaManagement.vue"),
        meta: { title: "额度管理", auth: true },
      },
      {
        path: "/evaluation",
        component: () => import("@/views/transaction/evaluation.vue"),
        meta: { title: "评价管理", auth: true },
      },
      {
        path: "/refundManagement",
        component: () => import("@/views/transaction/refundManagement.vue"),
        meta: { title: "退款管理", auth: true },
      },
      {
        path: "/FreightTateTemplate",
        component: () => import("@/views/transaction/FreightTateTemplate.vue"),
        meta: { title: "运费模板", auth: true },
      },
      {
        path: "/EDM_Setup",
        component: () => import("@/views/customer/EDM_Setup.vue"),
        meta: { title: "EDM设置", auth: true },
      },
      {
        path: "/customerAnalysis",
        component: () => import("@/views/customer/customerAnalysis.vue"),
        meta: { title: "客户分析", auth: true },
      },
      {
        path: "/customer_email",
        component: () => import("@/views/customer/customer_email.vue"),
        meta: { title: "模板管理", auth: true },
      },
      {
        path: "/market_activities",
        component: () => import("@/views/customer/market_activities.vue"),
        meta: { title: "营销活动", auth: true },
      },
      {
        path: "/customCategories",
        component: () => import("@/views/customer/customCategories.vue"),
        meta: { title: "自定义品类", auth: true },
      },

      {
        path: "/Store_Analysis",
        component: () => import("@/views/data_analysis/Store_Analysis.vue"),
        meta: { title: "店铺分析", auth: true },
      },
      {
        path: "/VisitorDetails",
        component: () => import("@/views/data_analysis/VisitorDetails.vue"),
        meta: { title: "访客详情", auth: true },
      },
      {
        path: "/marketplace",
        component: () => import("@/views/data_analysis/marketplace.vue"),
        meta: { title: "市场参谋", auth: true },
      },

      {
        path: "/product_staff",
        component: () => import("@/views/data_analysis/product_staff.vue"),
        meta: { title: "产品参谋", auth: true },
      },
      {
        path: "/selection_advisor",
        component: () => import("@/views/data_analysis/selection_advisor.vue"),
        meta: { title: "选词参谋", auth: true },
      },
      {
        path: "/traffic_staff",
        component: () => import("@/views/data_analysis/traffic_staff.vue"),
        meta: { title: "流量参谋", auth: true },
      },
      {
        path: "/buy_counsel",
        component: () => import("@/views/data_analysis/buy_counsel.vue"),
        meta: { title: "买家参谋", auth: true },
      },
      {
        path: "/intelligent_assistant",
        component: () => import("@/views/data_analysis/intelligent_assistant.vue"),
        meta: { title: "智能助手", auth: true },
      },
      {
        path: "/through_train",
        component: () => import("@/views/data_analysis/through_train.vue"),
        meta: { title: "直通车效果", auth: true },
      },
      {
        path: "/data_dictionary",
        component: () => import("@/views/data_analysis/data_dictionary.vue"),
        meta: { title: "数据字典", auth: true },
      },
      {
        path: "/AnalysisTransactions",
        component: () =>
          import("@/views/data_analysis/AnalysisTransactions.vue"),
        meta: { title: "交易分析", auth: true },
      },
      {
        path: "/performance_analysis",
        component: () =>
          import("@/views/data_analysis/performance_analysis.vue"),
        meta: { title: "履约分析", auth: true },
      },
      {
        path: "/VideoAnalysis",
        component: () => import("@/views/data_analysis/VideoAnalysis.vue"),
        meta: { title: "视频分析", auth: true },
      },
      {
        path: "/IndustryReport",
        component: () => import("@/views/data_analysis/IndustryReport.vue"),
        meta: { title: "行业报告", auth: true },
      },
      {
        path: "/AnalysisEmployees",
        component: () => import("@/views/data_analysis/AnalysisEmployees.vue"),
        meta: { title: "员工分析", auth: true },
      },


      {
        path: "/Industry_oriented_levy",
        component: () => import("@/views/product/Industry_oriented_levy.vue"),
        meta: { title: "行业定向征品", auth: true },
      },
      {
        path: "/product_customization_center",
        component: () =>
          import("@/views/product/product_customization_center.vue"),
        meta: { title: "产品定制中心", auth: true },
      },
      {
        path: "/product_catalog",
        component: () => import("@/views/product/product_catalog.vue"),
        meta: { title: "产品目录", auth: true },
      },
      {
        path: "/manage_certified_products",
        component: () =>
          import("@/views/product/manage_certified_products.vue"),
        meta: { title: "管理认证产品", auth: true },
      },
      {
        path: "/platform_new_product",
        component: () => import("@/views/product/platform_new_product.vue"),
        meta: { title: "管理平台新品", auth: true },
      },
      {
        path: "/learning_center",
        component: () => import("@/views/product/learning_center.vue"),
        meta: { title: "学习中心", auth: true },
      },
      {
        path: "/edit_navigation_template",
        component: () => import("@/views/product/edit_navigation_template.vue"),
        meta: { title: "编辑导航模板", auth: true },
      },
      {
        path: "/batch_delivery_management",
        component: () =>
          import("@/views/product/batch_delivery_management.vue"),
        meta: { title: "批量投放管理", auth: true },
      },
      {
        path: "/batch_upload",
        component: () => import("@/views/product/batch_upload.vue"),
        meta: { title: "批量上传", auth: true },
      },
      {
        path: "/service_access",
        component: () => import("@/views/transaction/service_access.vue"),
        meta: { title: "交易服务准入", auth: true },
      },
      {
        path: "/selling_service",
        component: () => import("@/views/transaction/selling_service.vue"),
        meta: { title: "OA赊销服务", auth: true },
      },

      {
        path: "/return_protection",
        component: () => import("@/views/transaction/return_protection.vue"),
        meta: { title: "无忧退货保障", auth: true },
      },
      {
        path: "/protection_service",
        component: () => import("@/views/transaction/protection_service.vue"),
        meta: { title: "拒付综合服务", auth: true },
      },
      {
        path: "/trading_introduction",
        component: () => import("@/views/transaction/trading_introduction.vue"),
        meta: { title: "在线交易介绍", auth: true },
      },
      {
        path: "/marketing_discount",
        component: () => import("@/views/market_center/marketing_discount.vue"),
        meta: { title: "营销折扣", auth: true },
      },
      {
        path: "/markingListAdd",
        component: () => import("@/views/market_center/markingListAdd.vue"),
        meta: { title: "添加营销活动", auth: true },
      },
      {
        path: "/cheaperCard",
        component: () => import("@/views/market_center/cheaperCard.vue"),
        meta: { title: "优惠券", auth: true },
      },
      {
        path: "/customers_add",
        component: () => import("@/views/customer/customers_add.vue"),
        meta: { title: "客户分群详情", auth: true },
      },
      {
        path: "/customerGroupId",
        component: () => import("@/views/customer/customerGroupId.vue"),
        meta: { title: "新建营销活动", auth: true },
      },
      {
        path: "/customer_mailadd",
        component: () => import("@/views/customer/customer_mailadd.vue"),
        meta: { title: "编辑模板", auth: true },
      },
      {
        path: "/customer_management",
        component: () => import("@/views/customer/customer_management.vue"),
        meta: { title: "客户管理", auth: true },
      },
      {
        path: "/media_center",
        component: () => import("@/views/media_center/media_center.vue"),
        meta: { title: "媒体中心", auth: true },
      },
      {
        path: "/video_material_center",
        component: () =>
          import("@/views/media_center/video_material_center.vue"),
        meta: { title: "视频素材中心", auth: true },
      },
      {
        path: "/media_release",
        component: () => import("@/views/media_center/media_release.vue"),
        meta: { title: "发布管理", auth: true },
      },
      {
        path: "/video_contribution",
        component: () => import("@/views/media_center/video_contribution.vue"),
        meta: { title: "视频投稿", auth: true },
      },
      {
        path: "/intelligent_sharing",
        component: () => import("@/views/media_center/intelligent_sharing.vue"),
        meta: { title: "SNS智能分享", auth: true },
      },
      {
        path: "/account_management",
        component: () => import("@/views/media_center/account_management.vue"),
        meta: { title: "SNS账号管理", auth: true },
      },
      {
        path: "/my_live_stream",
        component: () => import("@/views/media_center/my_live_stream.vue"),
        meta: { title: "我的直播", auth: true },
      },
      {
        path: "/live_broadcast_management",
        component: () =>
          import("@/views/media_center/live_broadcast_management.vue"),
        meta: { title: "直播管理", auth: true },
      },
      {
        path: "/live_broadcast_data",
        component: () => import("@/views/media_center/live_broadcast_data.vue"),
        meta: { title: "直播数据", auth: true },
      },
      {
        path: "/scene_purchase",
        component: () => import("@/views/media_center/scene_purchase.vue"),
        meta: { title: "3D家装场景购", auth: true },
      },
      {
        path: "/video_shooting_service",
        component: () =>
          import("@/views/media_center/video_shooting_service.vue"),
        meta: { title: "视频拍摄服务", auth: true },
      },
      {
        path: "/live_streaming_service",
        component: () =>
          import("@/views/media_center/live_streaming_service.vue"),
        meta: { title: "直播服务", auth: true },
      },
      {
        path: "/content_level",
        component: () => import("@/views/media_center/content_level.vue"),
        meta: { title: "内容等级", auth: true },
      },
      {
        path: "/video_task",
        component: () => import("@/views/media_center/video_task.vue"),
        meta: { title: "视频任务", auth: true },
      },
      {
        path: "/video_data",
        component: () => import("@/views/media_center/video_data.vue"),
        meta: { title: "视频数据", auth: true },
      },
      {
        path: "/activityList",
        component: () => import("@/views/market_center/activityList.vue"),
        meta: { title: "我的营销活动", auth: true },
      },
      {
        path: "/cheaperCardUpdate",
        component: () => import("@/views/market_center/cheaperCardUpdate.vue"),
        meta: { title: "创建优惠券", auth: true },
      },
      {
        path: "/scene_collocation",
        component: () => import("@/views/market_center/scene_collocation.vue"),
        meta: { title: "场景搭配", auth: true },
      },
      {
        path: "/shop_window",
        component: () => import("@/views/market_center/shop_window.vue"),
        meta: { title: "橱窗", auth: true },
      },
      {
        path: "/subscribe",
        component: () => import("@/views/opportunity/subscribe.vue"),
        meta: { title: "商机订阅", auth: true },
      },
    ],
  },
  {
    path: "/shopDecoration",
    component: () => import("@/views/store_mg/shopDecoration.vue"),
    meta: { title: "全球旺铺", auth: true },
  },
  {
    path: "/RFQdetail",
    component: () => import("@/views/opportunity/RFQdetail.vue"),
    meta: { title: "RFQ详情", auth: true },
  },
  {
    path: "/RFQform",
    component: () => import("@/views/opportunity/RFQform.vue"),
    meta: { title: "RFQ", auth: true },
  },
  {
    path: "/RFQsearch",
    component: () => import("@/views/opportunity/RFQsearch.vue"),
    meta: { title: "RFQ", auth: true },
  },
  {
    path: "/RFQdemand",
    component: () => import("@/views/goods/RFQdemand.vue"),
    meta: { title: "RFQ", auth: true },
  },
  {
    path: "/RFQdemandcomd",
    component: () => import("@/views/goods/RFQdemandcomd.vue"),
    meta: { title: "RFQ", auth: true },
  },
  {
    path: "/goodsOrder",
    component: () => import("@/views/goods/goodsOrder.vue"),
    meta: { title: "首页", auth: true },
  },

  {
    path: "/login",
    component: () => import("@/views/main/login.vue"),
    meta: { title: "登录" },
  },
  {
    path: "/release_edit",
    name: "release_edit",
    component: () => import("@/views/product/release_edit.vue"),
    meta: { title: "详情编辑", auth: true },
  },
  {
    path: "/release_product",
    name: "release_product",
    component: () => import("@/views/product/release_product.vue"),
    meta: { title: "发布产品", auth: true },
  },

  {
    path: "/release_detail",
    name: "release_detail",
    component: () => import("@/views/product/release_detail.vue"),
    meta: { title: "发布产品", auth: true, keepAlive: false },
  },
  {
    path: "/release_detail_edit",
    name: "release_detail_edit",
    component: () => import("@/views/product/release_detail_edit.vue"),
    meta: { title: "发布产品", auth: true, keepAlive: false },
  },

  {
    path: "/credit_guarantee",
    component: () => import("@/views/transaction/credit_guarantee.vue"),
    meta: { title: "信用保障", auth: true },
  },
  {
    path: "/credit_guarantee1",
    component: () => import("@/views/transaction/credit_guarantee1.vue"),
    meta: { title: "起草e收汇订单", auth: true },
  },
  {
    path: "/diagnostic_optimization",
    component: () => import("@/views/product/diagnostic_optimization.vue"),
    meta: { title: "产品诊断优化", auth: true },
  },
  {
    path: "/freight_template",
    component: () => import("@/views/transaction/freight_template.vue"),
    meta: { title: "运费模板产品管理", auth: true },
  },
  {
    path: "/freight_template_setting",
    component: () => import("@/views/transaction/freight_template_setting.vue"),
    meta: { title: "运费模板设置", auth: true },
  },
  {
    path: "/authIndex",
    component: () => import("@/views/main/authIndex.vue"),
    meta: { title: "", auth: true },
  },
  {
    path: "/authUpdates",
    component: () => import("@/views/main/authUpdates.vue"),
    meta: { title: "", auth: true },
  },
  {
    path: "/authQuerys",
    component: () => import("@/views/main/authQuerys.vue"),
    meta: { title: "", auth: true },
  },
  {
    path: "/service_opening",
    component: () => import("@/views/main/service_opening.vue"),
    meta: { title: "", auth: true },
  },
  {
    path: "/activity_registration",
    component: () => import("@/views/market_center/activity_registration.vue"),
    meta: { title: "官方活动报名", auth: true },
  },
  {
    path: "/addActivity",
    component: () => import("@/views/market_center/addActivity.vue"),
    meta: { title: "添加活动报名", auth: true },
  },
];

const router = new VueRouter({
  mode: "history",

  routes,
});
router.beforeEach((to, from, next) => {
  const elMain = document.querySelector(".el-main");
  if (elMain) {
    elMain.scrollTop = 0;
  }
  const flag = to.matched.some((item) => {
    return item.meta.auth;
  });
  const searchParams = new URLSearchParams(window.location.search);

  const gjzUseruuid = searchParams.get("gjz_useruuid");
  if (gjzUseruuid) {
    localStorage.setItem("guojizhan_user_uuid", gjzUseruuid);
  }
  if (flag) {
    const token = localStorage.getItem("guojizhan_user_uuid");

    if (!token) {
      next({
        path: "/login",
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
